import React from 'react';
import { MapPin, Phone, Mail, Heart } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-black text-white">
      <div className="container mx-auto px-4 sm:px-6 py-8 sm:py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
          {/* Brand */}
          <div className="sm:col-span-2">
            <div className="flex items-center space-x-2 sm:space-x-3 mb-3 sm:mb-4">
              <img
                src="/Hot%20Slice%20Pizza%20(1).png"
                alt="Hot Slice Pizza Logo"
                className="h-10 w-10 sm:h-12 sm:w-12 object-cover rounded-full"
              />
              <span className="text-lg sm:text-2xl font-bold font-pizza">Hot Slice Pizza</span>
              <div className="bg-green-600 text-white px-2 py-1 rounded-full text-xs font-bold">
                HALAL
              </div>
            </div>
            <p className="text-gray-300 mb-4 sm:mb-6 max-w-md leading-relaxed text-sm sm:text-base">
              A new family-owned restaurant bringing authentic halal Italian pizza, pasta, and appetizers to the heart of Seattle. 
              Experience the true flavors of Italy in every bite, made with love and traditional recipes.
            </p>
            <div className="flex items-center space-x-2 text-gray-300">
              <Heart className="h-4 w-4 text-red-500" />
              <span className="text-sm">Made with love in Seattle</span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-base sm:text-lg font-semibold mb-3 sm:mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li><a href="#home" className="text-gray-300 hover:text-red-400 transition-colors duration-200 text-sm sm:text-base">Home</a></li>
              <li><a href="#menu" className="text-gray-300 hover:text-red-400 transition-colors duration-200 text-sm sm:text-base">Menu</a></li>
              <li><a href="#about" className="text-gray-300 hover:text-red-400 transition-colors duration-200 text-sm sm:text-base">About</a></li>
              <li><a href="#catering" className="text-gray-300 hover:text-red-400 transition-colors duration-200 text-sm sm:text-base">Catering</a></li>
              <li><a href="#gift-cards" className="text-gray-300 hover:text-red-400 transition-colors duration-200 text-sm sm:text-base">Gift Cards</a></li>
              <li><a href="#contact" className="text-gray-300 hover:text-red-400 transition-colors duration-200 text-sm sm:text-base">Contact</a></li>
              <li><a href="#" className="text-gray-300 hover:text-red-400 transition-colors duration-200 text-sm sm:text-base">Order Online</a></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-base sm:text-lg font-semibold mb-3 sm:mb-4">Contact</h3>
            <div className="space-y-2 sm:space-y-3">
              <div className="flex items-start space-x-2 sm:space-x-3">
                <MapPin className="h-4 w-4 text-red-500 flex-shrink-0 mt-0.5" />
                <span className="text-gray-300 text-xs sm:text-sm">41 Dravus Street<br />Seattle, WA 98109</span>
              </div>
              <div className="flex items-center space-x-2 sm:space-x-3">
                <Phone className="h-4 w-4 text-green-500 flex-shrink-0" />
                <span className="text-gray-300 text-xs sm:text-sm">(206) 492-7765</span>
              </div>
              <div className="flex items-start space-x-2 sm:space-x-3">
                <Mail className="h-4 w-4 text-blue-500 flex-shrink-0 mt-0.5" />
                <span className="text-gray-300 text-xs sm:text-sm break-all">hotslicepizzaseattle@gmail.com</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 sm:mt-12 pt-6 sm:pt-8 flex flex-col md:flex-row items-center justify-between">
          <p className="text-gray-400 text-xs sm:text-sm mb-4 md:mb-0">
            © 2025 Hot Slice Pizza. All rights reserved.
          </p>
          <div className="flex flex-wrap justify-center space-x-4 sm:space-x-6 text-xs sm:text-sm">
            <a href="#" className="text-gray-400 hover:text-red-400 transition-colors duration-200">Privacy Policy</a>
            <a href="#" className="text-gray-400 hover:text-red-400 transition-colors duration-200">Terms of Service</a>
            <a href="#" className="text-gray-400 hover:text-red-400 transition-colors duration-200">Accessibility</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;